// Bits that more than one concierge screen needs. Nothing here renders a screen.

import { ApiError } from "../api";
import { Banner } from "../ui";

/** A quick reply button on a WhatsApp message. */
export interface MessageButton {
  id: string;
  title: string;
  /** Fallback buttons carry the reply that the tap sends back. */
  response?: string;
}

export interface UserLite {
  id: string;
  full_name: string;
  is_active?: boolean;
}

export interface UsersResponse {
  users?: UserLite[];
}

/**
 * The shell owns the URL and only re-reads it on popstate, so a programmatic
 * jump has to announce itself. Plain <a href> links are intercepted by the
 * shell and do not need this.
 */
export function navigate(to: string): void {
  window.history.pushState({}, "", to);
  window.dispatchEvent(new PopStateEvent("popstate"));
}

export function errMessage(err: unknown, fallback: string): string {
  if (err instanceof ApiError) return err.message || fallback;
  if (err instanceof Error && err.message) return err.message;
  return fallback;
}

/** Error state for a whole screen. The trace id is the only support handle. */
export function ErrorBanner({ error, what }: { error: unknown; what: string }) {
  if (!error) return null;
  const api = error instanceof ApiError ? error : null;
  return (
    <Banner tone="critical" traceId={api?.traceId}>
      {what}: {errMessage(error, "request failed")}
    </Banner>
  );
}

export function fmtDate(value: string | undefined | null): string {
  if (!value) return "-";
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? "-" : d.toLocaleString();
}

export function titleCase(value: string): string {
  return String(value || "")
    .replace(/_/g, " ")
    .replace(/\b\w/g, (c) => c.toUpperCase());
}
